<template>
    <div>
        <div class="container bg-alchemy-two rounded" :style="`height: ${timelineHeight}px; border: solid 1px rgb(0,0,0)`">
            <div class="timeline">
                <ul>
                    <li class="timeline-content" style="" v-for="(event, i) in events" v-bind:key="i+1" >
                        <p class="date fs-5 p-2" style="border-bottom: solid 3px rgb(115, 70, 205); border-radius: 10%; text-shadow: 2px 2px 5px white;">{{event.datetime}}</p>
                        <h1 class="text-start mt-1" style="letter-spacing: 5px; text-shadow: 2px 1px 3px white;">{{event.total}} Event(s)</h1>
                        <hr class="mt-2" style="color: rgb(115, 70, 205); height: 2px;">
                        <div class="input-group flex-nowrap mt-3"  v-for="(element, j) in event.elements" v-bind:key="j+1">
                            <button class="btn rounded bg-gradient fs-3" :class="{
                              'btn-alchemy-success': element.severity == 'CLEAR',
                              'btn-alchemy-warning': element.severity == 'MINOR',
                              'btn-alchemy-danger': element.severity == 'MAJOR'
                            }" style="height: 85px; width: 13%;" data-bs-toggle="tooltip" data-bs-placement="top" :title="`Event: ${element.name}\nSeverity: ${element.severity}`" @click="viewEvent(event, element)">
                                <i class="fa-solid fa-xl" :class="{
                                  'fa-heart-pulse': element.type=='status',
                                  'fa-microchip': element.type=='cpu',
                                  'fa-memory':    element.type=='memory',
                                  'fa-link':       element.type=='ping',
                                  'fa-gear':      element.type=='process',
                                  'fa-clock':     element.type=='process-timeout',
                                  'fa-ethernet':  element.type=='target-interface',
                                  'fa-gears':     element.type=='target-os-service'
                                }" style="text-shadow: 3px 1px 3px Black;"></i>
                            </button>
                            <div class="ms-1" style="width: 87%;">
                              <div class="input-group flex-nowrap rounded">
                                <button class="btn bg-gradient text-white p-2" style="width: 10%;" title="Device Name / Event Name">
                                  <i class="fa-solid fa-xl fa-info"></i>
                                </button>
                                <input class="btn fw-bold text-start p-2 fw-light w-100 rounded bg-gradient" :class="{'btn-alchemy-success text-white': element.severity == 'CLEAR','btn-alchemy-warning': element.severity == 'MINOR','btn-alchemy-danger text-white': element.severity == 'MAJOR'}"  type="text" style=" font-size: 15px; letter-spacing: 1px;" :value="`${element.parent} / ${element.name}`" :title="capitalize(element.description)" readonly>
                              </div>
                              <div class="input-group flex-nowrap rounded mt-1">
                                <button class="btn bg-gradient text-white p-2" style="width: 10%;" title="Event Message">
                                  <i class="fa-solid fa-xl fa-message"></i>
                                </button>
                                <input class="btn text-start p-2 fw-light w-100 rounded bg-gradient" :class="{'btn-alchemy-success text-white': element.severity == 'CLEAR','btn-alchemy-warning': element.severity == 'MINOR','btn-alchemy-danger text-white': element.severity == 'MAJOR'}"  type="text" style=" font-size: 13px;" :value="`${element.description}`" title="Event Description" readonly>
                              </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="false" class="bg-dark mt-1 rounded">
            <div class="input-group flex-nowrap mt-2">
                <button class="btn me-1" :class="`btn-${see.state}`" style="height: 40px; width: 10%;" data-bs-toggle="tooltip" data-bs-placement="top" title="Click here to view details below.">
                    <i class="fa-solid fa-xl" :class="`fa-${see.icon}`"></i>
                </button>
                <input class="btn btn-dark fs-6 me-1"  type="text" style="height: 40px; width: 40%;" :value="see.name" readonly>
                <input class="btn btn-dark fs-6 me-1 mt-1 fw-light"  type="text" style="height: 40px; width: 50%;" :value="sev.datetime" :title="capitalize(sev.datetime)" readonly>
            </div>
            <div class="input-group flex-nowrap mt-2">
                <input class="btn btn-dark fs-6"  type="text" style="width: 100%; height: 45px;" :value="capitalize(see.description)" :title="capitalize(see.description)" readonly>
            </div>
        </div>
    </div>
</template>


<script>

export default {
  name: 'Timeline',
  props:{
    timelineHeight: String,
    events: Object
  },
  data() {
      return {
        appServiceUrl: process.env.VUE_APP_SERVICE_URL,
        appName: process.env.VUE_APP_SERVICE_NAME,
        sev: {datetime: "Datetime"}, // Selected Event
        see: {name: "Event Name", description: "Description", icon: "info", state: "dark"} // Selected Element
      }
  },
  methods: {
    capitalize(_string){
      const lower = _string.toLowerCase()
      return _string.charAt(0).toUpperCase() + lower.slice(1)
    },
    resetVisor(){
        this.sev = {datetime: "Datetime"}
        this.see = {name: "Event Name", description: "Description", icon: "info", state: "dark"}
    },
    viewEvent(_event, _element){
        this.sev = _event
        this.see = _element
    }
  },
  mounted: function(){}
}
</script>

<style scoped>
    @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@300;500&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html {
  font-family: "Montserrat";
}
.container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  overflow-y: scroll;
}
.timeline {
  width: 90%;
  height: auto;
  margin: auto auto;
  position: relative;
}

.timeline ul {
  list-style: none;
}
.timeline ul li {
  padding: 20px;
  background-color: #000000;
  color: rgb(3, 249, 228);
  border-radius: 10px;
  margin-bottom: 20px;
}
.timeline ul li:last-child {
  margin-bottom: 0;
}
.timeline-content h1 {
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  margin-bottom: 10px;
}
.timeline-content p {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
}
.timeline-content .date {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 10px;
  letter-spacing: 2px;
}
@media only screen and (min-width: 768px) {
  .timeline:before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 100%;
    background-color: rgb(115, 70, 205);
  }
  .timeline ul li {
    width: 50%;
    position: relative;
    margin-bottom: 50px;
  }
  .timeline ul li:nth-child(odd) {
    float: left;
    clear: right;
    transform: translateX(-30px);
    border-radius: 20px 0px 20px 20px;
  }
  .timeline ul li:nth-child(even) {
    float: right;
    clear: left;
    transform: translateX(30px);
    border-radius: 0px 20px 20px 20px;
  }
  .timeline ul li::before {
    content: "";
    position: absolute;
    height: 5px;
    width: 60px;
    border-radius: 40%;
    background-color: rgb(115, 70, 205);
    top: 0px;
    transition-duration: 0.7s;
  }
  .timeline ul li:nth-child(odd)::before {
    transform: translate(50%, -50%);
    right: -30px;
  }
  .timeline ul li:nth-child(even)::before {
    transform: translate(-50%, -50%);
    left: -30px;
  }
  .timeline-content .date {
    position: absolute;
    top: -35px;
  }
  .timeline ul li:hover::before {
    background-color: rgb(188, 159, 246);
  }
}

  .btn-alchemy-success{
    background-color: rgb(115, 70, 205);
    color: White;
  }
  .btn-alchemy-danger{
    background-color: rgb(161, 91, 0);
    color: White;
  }
  .btn-alchemy-warning{
    background-color: rgb(187, 255, 0);
    color: rgb(0, 0, 0);
  }
  .bg-alchemy-dark{
    background-color: rgb(0,0,26);
    color: White;
  }
  .bg-alchemy-two{
    background-color: rgb(0, 0, 26);
    color: White;
    transition-duration: 0.7s;
  }


  .border-alchemy{
    border: solid 2px rgb(115,70,205);
  }
  .border-top-alchemy{
    border-top: solid 2px rgb(115,70,205);
  }
  .border-bottom-alchemy{
    border-bottom: solid 2px rgb(115,70,205);
  }
  .border-start-alchemy{
    border-left: solid 2px rgb(115,70,205);
  }
  .border-end-alchemy{
    border-right: solid 2px rgb(115,70,205);
  }

</style>